export const MediaTypeEnum = {
  IMAGE: 'IMAGE',
  IMAGE_INSIDE_360: 'IMAGE_INSIDE_360',
  VIDEO: 'VIDEO',
  VIDEO_360: 'VIDEO_360',
  DOCUMENT: 'DOCUMENT'
} as const;

export type MediaTypeEnum = typeof MediaTypeEnum[keyof typeof MediaTypeEnum];
